import { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { mockApi } from "../../services/mockApi";
import Swal from "sweetalert2";

import ModalConfirmLogout from "../../components/ModalConfirmLogout";

interface TableItem {
  time?: string;
  percent: number;
  typeGame?: string;
  name: string;
  _id: string;
  showIcon?: string;
  vassalage?: string;
  normalizedName?: string;
}

const Slot = () => {
  const MOBILE_BREAKPOINT = 430;
  const MOBILE_INITIAL_VISIBLE = 12;
  const DESKTOP_INITIAL_VISIBLE = 40;
  const MOBILE_STEP_VISIBLE = 12;
  const DESKTOP_STEP_VISIBLE = 40;

  const [isShowLogout, setIsShowLogout] = useState(false);
  const [tableList, setTableList] = useState<TableItem[]>([]);
  const [visibleCount, setVisibleCount] = useState(
    typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT
      ? MOBILE_INITIAL_VISIBLE
      : DESKTOP_INITIAL_VISIBLE
  );
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= MOBILE_BREAKPOINT : false
  );
  const [userInfo, setUserInfo] = useState<any>(null);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const scrollTickingRef = useRef(false);
  const { room } = useParams();
  const navigate = useNavigate();

  // Bỏ dấu tiếng Việt (kể cả đ, ư, ơ, ă, â, ê, ô) để tìm dễ
  const normalizeString = (str: string) => {
    const s = str.toLowerCase();
    const from = "àáảãạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệìíỉĩịòóỏõọôồốổỗộơờớởỡợùúủũụưừứửữựỳýỷỹỵđ";
    const to = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeiiiiiooooooooooooooooouuuuuuuuuuuyyyyyd";
    let out = "";
    for (let i = 0; i < s.length; i++) {
      const idx = from.indexOf(s[i]);
      out += idx >= 0 ? to[idx] : s[i];
    }
    return out.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const filteredTableList = tableList;

  // Loading frame for both mobile and PC
  useEffect(() => {
    
    Swal.fire({
      html: `
        <div style="
          border: 2px solid transparent;
          border-image: linear-gradient(45deg, #8a2be2, #00bfff, #ff0096, #8a2be2) 1;
          border-radius: 20px;
          padding: 40px;
          text-align: center;
          color: white;
          max-width: 350px;
          width: 90%;
          box-shadow: 
            0 0 50px rgba(138, 43, 226, 0.6),
            0 0 100px rgba(0, 191, 255, 0.3),
            0 0 150px rgba(255, 0, 150, 0.2),
            0 20px 60px rgba(0, 0, 0, 0.7),
            inset 0 0 40px rgba(138, 43, 226, 0.15),
            inset 0 0 80px rgba(0, 191, 255, 0.1);
          position: relative;
          font-family: 'Courier New', monospace;
        ">
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 30px;
            animation: textGlow 2s ease-in-out infinite;
          ">
            <div style="
              width: 80px;
              height: 80px;
              background: linear-gradient(135deg, #8a2be2, #00bfff);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 20px;
              font-size: 40px;
              color: #000;
              font-weight: bold;
              box-shadow: 
                0 0 20px rgba(138, 43, 226, 0.6),
                0 0 40px rgba(0, 191, 255, 0.3);
              animation: iconPulse 1.5s ease-in-out infinite;
              border: 2px solid rgba(255, 255, 255, 0.3);
            ">⚡</div>
            <h2 style="
              margin: 0; 
              color: #8a2be2; 
              font-size: 20px; 
              font-weight: 900;
              text-shadow: 
                0 0 15px rgba(138, 43, 226, 0.8),
                0 0 25px rgba(138, 43, 226, 0.5);
              letter-spacing: 2px;
              text-transform: uppercase;
              text-align: center;
              line-height: 1.2;
            ">INITIALIZING HACK TOOL...</h2>
          </div>
          
          <div style="
            margin-bottom: 25px; 
            font-size: 14px;
            display: flex;
            flex-direction: column;
            gap: 8px;
          ">
            <div style="
              padding: 8px 16px;
              background: rgba(255, 255, 255, 0.05);
              border-radius: 6px;
              border: 1px solid rgba(255, 255, 255, 0.1);
              animation: progressGlow 1.5s ease-in-out infinite;
              text-align: center;
            ">
              <span style="color: rgba(255, 255, 255, 0.9); font-weight: 500;">Đang tải dữ liệu sảnh game...</span>
            </div>
            <div data-progress="2" style="
              padding: 8px 16px;
              background: rgba(255, 255, 255, 0.05);
              border-radius: 6px;
              border: 1px solid rgba(255, 255, 255, 0.1);
              animation: progressGlow 1.5s ease-in-out infinite 0.5s;
              text-align: center;
            ">
              <span style="color: rgba(255, 255, 255, 0.9); font-weight: 500;">Đang tải danh sách game...</span>
            </div>
          </div>
          
          <div style="
            width: 100%;
            height: 16px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            overflow: hidden;
            margin-bottom: 15px;
            position: relative;
          ">
            <div id="progress-fill" style="
              width: 0%;
              height: 100%;
              background: linear-gradient(90deg, #8a2be2, #00bfff, #ff0096, #8a2be2);
              border-radius: 4px;
              transition: width 0.3s ease;
              box-shadow: 0 0 10px rgba(138, 43, 226, 0.5);
            "></div>
            <div id="progress-text" style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              color: white;
              font-size: 12px;
              font-weight: bold;
              text-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
            ">0%</div>
          </div>
          
          <div style="
            font-size: 14px; 
            color: #00bfff;
            text-shadow: 0 0 10px rgba(0, 191, 255, 0.5);
            letter-spacing: 1px;
          ">
            » HACK TOOL READY «
          </div>
        </div>
        
        <style>
          .loading-frame-popup {
            z-index: 99999 !important;
          }
          @keyframes textGlow {
            0%, 100% { text-shadow: 0 0 10px rgba(138, 43, 226, 0.5); }
            50% { text-shadow: 0 0 20px rgba(138, 43, 226, 0.8); }
          }
          @keyframes iconPulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.1); }
          }
          @keyframes progressGlow {
            0%, 100% { 
              background: rgba(255, 255, 255, 0.05);
              border-color: rgba(255, 255, 255, 0.1);
            }
            50% { 
              background: rgba(138, 43, 226, 0.1);
              border-color: rgba(138, 43, 226, 0.3);
            }
          }
          @keyframes progressBar {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        </style>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      background: 'rgba(0, 0, 0, 0.7)',
      customClass: {
        popup: 'loading-frame-popup'
      },
      backdrop: `
        rgba(0, 0, 0, 0.7)
        url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%238a2be2' fill-opacity='0.15'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
        center/15px
      `
    });

    // Progress bar animation
    let progress = 0;
    const progressInterval = setInterval(() => {
      progress += 3.34; // 100% in ~3 seconds (update every 100ms)
      if (progress > 100) progress = 100;
      
      const progressFill = document.getElementById('progress-fill');
      const progressText = document.getElementById('progress-text');
      
      if (progressFill && progressText) {
        progressFill.style.width = progress + '%';
        progressText.textContent = Math.round(progress) + '%';
      }
      
      // Show "Đã hack thành công!" when progress reaches 100%
      if (progress >= 100) {
        const lastMessage = document.querySelector('[data-progress="2"]');
        if (lastMessage) {
          lastMessage.innerHTML = '<span style="color: rgba(255, 255, 255, 0.9); font-weight: 500;">Đã hack thành công!</span>';
        }
        clearInterval(progressInterval);
      }
    }, 100);

    // Close loading after 3 seconds
    setTimeout(() => {
      clearInterval(progressInterval);
      Swal.close();
      // Keep isLoading as true to show content
    }, 3000);

    let isMounted = true;

    const fetchTableList = async () => {
      try {
        // TẤT CẢ sảnh đều dùng mock API
        if (room) {
          const mockResponse = await mockApi.getTableList(room);
          if (isMounted) {
            const optimizedData = (mockResponse.data || []).map((item: TableItem) => ({
              ...item,
              normalizedName: normalizeString(item.name || ""),
            }));
            setTableList(optimizedData);
          }
        }
      } catch (error) {
        console.error('Error fetching table list:', error);
      }
    };

    fetchTableList();
    window.scrollTo(0, 0);
    setVisibleCount(isMobile ? MOBILE_INITIAL_VISIBLE : DESKTOP_INITIAL_VISIBLE);

    return () => {
      isMounted = false;
    };
  }, [room, isMobile]);

  // Track viewport width to adjust header/search layout only on mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    try {
      const storedUser = localStorage.getItem("user_info");
      if (storedUser) setUserInfo(JSON.parse(storedUser));
    } catch {
      setUserInfo(null);
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setVisibleCount((prev) =>
      Math.max(prev, isMobile ? MOBILE_INITIAL_VISIBLE : DESKTOP_INITIAL_VISIBLE)
    );
  }, [isMobile]);

  // Infinite scroll: tăng dần số lượng item hiển thị khi scroll gần cuối trang
  useEffect(() => {
    const handleScroll = () => {
      if (scrollTickingRef.current) return;
      scrollTickingRef.current = true;
      requestAnimationFrame(() => {
        const scrollPosition = window.innerHeight + window.scrollY;
        const threshold = document.body.offsetHeight - (isMobile ? 260 : 400);
        if (scrollPosition >= threshold) {
          setVisibleCount((prev) => {
            const maxVisible = filteredTableList.length || tableList.length;
            if (prev >= maxVisible) return prev;
            const step = isMobile ? MOBILE_STEP_VISIBLE : DESKTOP_STEP_VISIBLE;
            return Math.min(prev + step, maxVisible);
          });
        }
        scrollTickingRef.current = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [filteredTableList.length, tableList.length, isMobile]);

  const visibleTableList = useMemo(
    () => filteredTableList.slice(0, visibleCount),
    [filteredTableList, visibleCount]
  );

  useEffect(() => {
    localStorage.setItem("NH_PAGE", String(room));
  }, [room]);

  const displayName = userInfo?.userName || userInfo?.username || "Xiaofeng";
  const formatCoins = (coins?: number) => Number(coins ?? 9999999).toLocaleString("en-US");
  const hallName = (room || "PG").toUpperCase();
  const getGameImage = (item: TableItem, index: number) =>
    item.showIcon ||
    `/assets/NH/${room}/${room}_${(index + 1).toString().padStart(2, "0")}.png`;

  const handleGameClick = (item: TableItem, imageUrl: string) => {
    localStorage.setItem("title_img", imageUrl);
    localStorage.setItem("title_text", item.name);
    localStorage.setItem("win_percent", item.percent.toString());
    navigate(`/NH/table/${item._id}`);
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Video background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
          backgroundSize: "contain",
          backgroundRepeat: "repeat",
          backgroundPosition: "top"
        }}
      >
        <source
          src={isMobile ? "/assets/bg-mb.mp4" : "/assets/bg-pc.mp4"}
          type="video/mp4"
        />
      </video>
      <style>
        {`
          .slot-page {
            min-height: 100vh;
            color: #fff;
            font-family: "Roboto", Arial, sans-serif;
            overflow-x: hidden;
          }

          .slot-topbar {
            position: relative;
            z-index: 2;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: 18px 84px 0;
          }

          .slot-brand {
            width: 250px;
            max-width: 32vw;
            object-fit: contain;
            filter: drop-shadow(0 0 10px rgba(0, 238, 255, 0.35));
          }

          .slot-user-panel {
            width: 300px;
            max-width: 34vw;
          }

          .slot-user-row {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .slot-pill {
            height: 38px;
            border-radius: 9px;
            border: 1px solid rgba(0, 238, 255, 0.35);
            background: rgba(1, 16, 52, 0.72);
            box-shadow: 0 0 16px rgba(0, 119, 255, 0.35), inset 0 0 18px rgba(0, 119, 255, 0.18);
            display: flex;
            align-items: center;
            color: #fff;
            font-weight: 900;
          }

          .slot-user-pill {
            flex: 1;
            min-width: 0;
            padding: 0 10px;
            gap: 8px;
            cursor: pointer;
            user-select: none;
          }

          .slot-coin-pill {
            min-width: 132px;
            padding: 0 12px;
            gap: 8px;
            color: #ffd747;
          }

          .slot-vip {
            margin-left: auto;
            padding: 3px 8px;
            border-radius: 5px;
            background: linear-gradient(180deg, #ff5a47, #a90e18);
            color: #fff;
            font-size: 10px;
            line-height: 1;
          }

          .slot-menu {
            margin-top: 8px;
            margin-left: 2px;
            width: 142px;
            padding: 8px 12px;
            border-radius: 8px;
            border: 1px solid rgba(0, 238, 255, 0.34);
            background: rgba(1, 16, 52, 0.68);
            box-shadow: 0 0 16px rgba(0, 119, 255, 0.25);
            text-align: center;
            font-weight: 700;
            color: #ffff00;
            cursor: pointer;
          }

          .slot-hero {
            position: relative;
            z-index: 1;
            margin-top: 22px;
            text-align: center;
          }

          .slot-back {
            position: absolute;
            left: 150px;
            top: 32px;
            display: inline-flex;
            align-items: center;
            gap: 7px;
            border: 1px solid rgba(0, 238, 255, 0.38);
            border-radius: 999px;
            padding: 5px 14px 6px 8px;
            background: rgba(3, 34, 90, 0.75);
            color: #fff;
            font-weight: 800;
            font-size: 16px;
            text-decoration: none;
            box-shadow: 0 0 14px rgba(0, 119, 255, 0.42);
          }

          .slot-back-dot {
            width: 22px;
            height: 22px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: linear-gradient(180deg, #1685ff, #0649a5);
            box-shadow: inset 0 0 7px rgba(255, 255, 255, 0.24);
            font-size: 18px;
          }

          .slot-title-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 402px;
            padding: 13px 28px 15px;
            border-radius: 999px;
            background: linear-gradient(180deg, rgba(14, 74, 177, 0.74), rgba(23, 5, 105, 0.7));
            border: 1px solid rgba(0, 238, 255, 0.28);
            box-shadow: 0 0 22px rgba(0, 119, 255, 0.6), inset 0 0 20px rgba(0, 238, 255, 0.18);
            overflow: visible;
          }

          .slot-title {
            font-size: 36px;
            font-weight: 900;
            line-height: 1.22;
            letter-spacing: 0.02em;
            background: linear-gradient(90deg, #00fbff 0%, #ff00ff 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
            filter: drop-shadow(0 0 16px rgba(0, 238, 255, 0.7));
            display: inline-block;
            padding-top: 0.08em;
          }

          .slot-subtitle {
            margin-top: 14px;
            font-size: 22px;
            line-height: 1.2;
            color: rgba(255, 255, 255, 0.94);
            text-shadow: 0 0 12px rgba(0, 119, 255, 0.45);
          }

          .slot-games {
            position: relative;
            z-index: 1;
            max-width: 1520px;
            margin: 24px auto 0;
            display: grid;
            grid-template-columns: repeat(6, minmax(0, 1fr));
            gap: 26px 28px;
            padding: 0 42px 80px;
          }

          .slot-game-card {
            position: relative;
            min-width: 0;
            aspect-ratio: 0.78;
            border-radius: 20px;
            padding: 15px 15px 12px;
            background: linear-gradient(135deg, #00eeff 0%, #0077ff 45%, #00eeff 100%);
            border: none;
            box-shadow:
              0 0 16px rgba(0, 238, 255, 0.85),
              0 0 30px rgba(0, 119, 255, 0.28),
              inset 0 0 20px rgba(0, 119, 255, 0.25);
            clip-path: polygon(9% 0, 91% 0, 100% 9%, 100% 91%, 91% 100%, 9% 100%, 0 91%, 0 9%);
            cursor: pointer;
            transition: transform 0.2s ease, filter 0.2s ease;
          }

          .slot-game-card::before {
            content: "";
            position: absolute;
            inset: 2px;
            z-index: 0;
            border-radius: inherit;
            clip-path: inherit;
            background: linear-gradient(180deg, rgba(0, 20, 76, 0.96), rgba(0, 7, 38, 0.98));
            pointer-events: none;
          }

          .slot-game-card:hover {
            transform: translateY(-4px) scale(1.03);
            filter: brightness(1.1);
          }

          .slot-game-image {
            position: relative;
            z-index: 1;
            width: 100%;
            height: 72%;
            border-radius: 14px;
            object-fit: cover;
            display: block;
          }

          .slot-game-name {
            position: relative;
            z-index: 1;
            margin-top: 12px;
            color: #fff;
            font-size: 16px;
            font-weight: 900;
            line-height: 1.2;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-transform: uppercase;
          }

          .slot-game-meta {
            position: relative;
            z-index: 1;
            margin-top: 4px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            font-size: 10px;
            font-weight: 900;
          }

          .slot-game-ai {
            color: #00fbff;
          }

          .slot-game-rate {
            color: #ff00ff;
          }

          .slot-game-progress-row {
            position: relative;
            z-index: 1;
            margin-top: 4px;
            display: flex;
            align-items: center;
            gap: 7px;
          }

          .slot-game-progress {
            flex: 1;
            height: 5px;
            border-radius: 999px;
            background: #0047ab;
            overflow: hidden;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.35);
          }

          .slot-game-progress-fill {
            height: 100%;
            border-radius: inherit;
            background: linear-gradient(90deg, #00fbff 0%, #ff00ff 100%);
            box-shadow: 0 0 8px rgba(255, 0, 255, 0.65);
          }

          .slot-game-progress-value {
            min-width: 22px;
            text-align: right;
            font-size: 9px;
            font-weight: 900;
            color: #00fbff;
          }

          @media (max-width: 1024px) {
            .slot-topbar {
              padding: 14px 14px 0;
              flex-direction: column;
              align-items: center;
              gap: 12px;
            }

            .slot-brand {
              width: 210px;
              max-width: 82vw;
            }

            .slot-user-panel {
              width: min(340px, calc(100vw - 28px));
              max-width: none;
            }

            .slot-user-row {
              gap: 8px;
              width: 100%;
            }

            .slot-user-pill {
              flex: 1 1 auto;
            }

            .slot-coin-pill {
              min-width: 126px;
              flex: 0 0 auto;
            }

            .slot-hero {
              margin-top: 24px;
              padding: 0 14px;
            }

            .slot-back {
              position: relative;
              left: auto;
              top: auto;
              margin: 0 auto 16px;
            }

            .slot-title-badge {
              min-width: 0;
              max-width: calc(100vw - 32px);
              padding: 12px 20px 14px;
            }

            .slot-title {
              font-size: 26px;
            }

            .slot-subtitle {
              font-size: 16px;
            }

            .slot-games {
              grid-template-columns: repeat(3, 1fr);
              gap: 16px;
              padding: 0 16px 70px;
            }
          }

          @media (max-width: 560px) {
            .slot-topbar {
              align-items: center;
            }

            .slot-user-row {
              flex-direction: row;
              align-items: center;
              gap: 8px;
            }

            .slot-pill {
              height: 34px;
              font-size: 12px;
            }

            .slot-games {
              grid-template-columns: repeat(2, 1fr);
              gap: 14px 12px;
              padding-left: 12px;
              padding-right: 12px;
            }

            .slot-game-card {
              border-radius: 18px;
              padding: 10px 10px 9px;
            }

            .slot-game-image {
              border-radius: 12px;
              height: 70%;
            }

            .slot-game-name {
              margin-top: 8px;
              font-size: 12px;
            }

            .slot-game-meta {
              font-size: 9px;
            }

            .slot-game-progress-value {
              font-size: 8px;
              min-width: 20px;
            }
          }
        `}
      </style>

      <div className="slot-page">
        <div className="slot-topbar">
          <img className="slot-brand" src="/assets/logo-header.png" alt="Velixia Slot" />

          <div className="slot-user-panel">
            <div className="slot-user-row">
              <div
                className="slot-pill slot-user-pill"
                role="button"
                tabIndex={0}
                onClick={() => setIsUserMenuOpen((prev) => !prev)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    setIsUserMenuOpen((prev) => !prev);
                  }
                }}
              >
                <img src="/assets/icon-user.png" alt="" style={{ width: 26, height: 26 }} />
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{displayName}</span>
                <span className="slot-vip">VIP 10</span>
              </div>
              <div className="slot-pill slot-coin-pill">
                <span
                  style={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(180deg, #ffd64b, #d28b00)",
                    color: "#8a4b00",
                    fontWeight: 900,
                  }}
                >
                  $
                </span>
                <span>{formatCoins(userInfo?.coins)}</span>
              </div>
            </div>

            {isUserMenuOpen && (
              <div className="slot-menu" onClick={() => setIsShowLogout(true)}>
                Đăng xuất
              </div>
            )}
          </div>
        </div>

        <section className="slot-hero">
          <a className="slot-back" href="/NH">
            <span className="slot-back-dot">‹</span>
            <span>Quay lại</span>
          </a>
          <div className="slot-title-badge">
            <span className="slot-title">CHỌN GAME | SẢNH {hallName}</span>
          </div>
          <div className="slot-subtitle">Lựa chọn game phù hợp để bắt đầu trải nghiệm</div>
        </section>

        <section className="slot-games" aria-label="Danh sách game">
          {visibleTableList.length > 0 ? (
            visibleTableList.map((item, index) => {
              const imageUrl = getGameImage(item, index);

              return (
                <article
                  key={item._id || index}
                  className="slot-game-card"
                  onClick={() => handleGameClick(item, imageUrl)}
                >
                  <img
                    className="slot-game-image"
                    src={imageUrl}
                    alt={item.name}
                    loading="lazy"
                    onError={(ev) => (ev.currentTarget.src = "/assets/demo-card.png")}
                  />
                  <div className="slot-game-name" title={item.name}>
                    {item.name}
                  </div>
                  <div className="slot-game-meta">
                    <span className="slot-game-ai">Hiệu suất AI</span>
                  </div>
                  <div className="slot-game-progress-row">
                    <div className="slot-game-progress">
                      <div className="slot-game-progress-fill" style={{ width: `${item.percent}%` }} />
                    </div>
                    <span className="slot-game-progress-value">{item.percent}%</span>
                  </div>
                </article>
              );
            })
          ) : (
            <div className="col-span-full text-center text-white py-20">
              <div className="text-2xl font-bold mb-4">Không có dữ liệu game</div>
              <div className="text-lg opacity-75">Vui lòng thử lại sau hoặc liên hệ admin</div>
            </div>
          )}
        </section>
      </div>
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default Slot;
